// extracted by mini-css-extract-plugin
module.exports = {"inlineAd":"JQ","innerWrapper":"KQ","tooltipWrapper":"LQ","icon":"MQ","tooltip":"NQ","content":"OQ"};